import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import { BUTTON_TEXT } from "../../constants";

const FeatureFlagEditButton = ({ testId, className, onClick }) => {
  return (
    <FontAwesomeIcon
      icon={faEdit}
      role="button"
      title={BUTTON_TEXT.EDIT}
      aria-hidden="true"
      data-testid={testId}
      className={className}
      onClick={onClick}
    />
  );
};

export default FeatureFlagEditButton;
